import axiosPrivate from "./axiosPrivate";

const getPlanillaAdministracion = (periodo_planilla) => {
  return axiosPrivate.get(`planilla-administracion`, { params: { periodo_planilla } })
    .then(response => response.data);
};

const guardarPlanillaAdministracion = (data) => {
  return axiosPrivate.post(`planilla-administracion`, data)
    .then(response => response.data);
};

const validarPlanillaAdministracion = (periodo_planilla, perfil_id) => {
  return axiosPrivate.post(`planilla-administracion/validar`, { periodo_planilla, perfil_id })
    .then(response => response.data);
};

const getUsuariosParaPlanilla = () => {
    return axiosPrivate.get(`planilla-administracion/usuarios`)
      .then(response => response.data);
};

const getDescuentosPlanillaResumen = (periodo) => {
    return axiosPrivate.get(`descuentos-planilla/resumen`, { params: { periodo } })
      .then(response => response.data);
};

const actualizarPago = (data) => {
  return axiosPrivate.post(`planilla-administracion/actualizar-pago`, data)
    .then(response => response.data);
};

export default {
    getPlanillaAdministracion,
    guardarPlanillaAdministracion,
    validarPlanillaAdministracion,
    getUsuariosParaPlanilla,
    getDescuentosPlanillaResumen,
    actualizarPago
};
